import { useEffect } from 'react';
import { setCanonical, setMeta } from '../utils/seo';
import { SponsorBanner, AdSensePlaceholder } from './AdSlots';

export default function PrivacyPage() {
  useEffect(() => { setCanonical('/privacy'); setMeta('Privacy Policy', 'TrueFitGuide privacy policy - how we handle your data.'); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-12">
      <h1 className="font-['Cormorant_Garamond'] text-4xl font-light tracking-tighter text-[#1C1917] mb-8">Privacy Policy</h1>
      <div className="space-y-6 text-sm text-[#78716C] leading-relaxed">
        <h2 className="font-['Cormorant_Garamond'] text-2xl font-semibold text-[#1C1917]">Your Privacy is Important to Us</h2>

        <h3 className="text-lg font-semibold text-[#1C1917]">Information We Collect</h3>
        <p>This clothing size platform operates entirely in your browser and uses local storage to enhance your experience. We collect and store the following information locally on your device:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Your size preferences and search history</li>
          <li>Personal preferences (unit system, favorite brands)</li>
          <li>Usage analytics (session counts, tools used)</li>
          <li>Cookie consent preferences</li>
          <li>Accessibility widget settings</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1C1917]">How We Use Your Information</h3>
        <p>All information is stored locally in your browser's storage and is used to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Personalize your sizing experience</li>
          <li>Remember your preferences between visits</li>
          <li>Provide relevant content and recommendations</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1C1917]">Data Storage and Security</h3>
        <p>Your data is stored exclusively in your browser's local storage. This means:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>No personal information is transmitted to external servers</li>
          <li>Your data remains on your device and under your control</li>
          <li>You can clear this data at any time through your browser settings</li>
          <li>No account creation or personal identification is required</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1C1917]">AI Chatbot</h3>
        <p>Our website features an AI-powered size guide ("Sarah") that can answer general questions about clothing sizes. Conversations with the chatbot are processed by third-party AI services (OpenAI) to generate responses. Chat messages are not stored permanently or linked to any personal identity. The chatbot is an AI assistant and does not provide professional sizing advice.</p>

        <h3 className="text-lg font-semibold text-[#1C1917]">Third-Party Services and Advertising</h3>
        <p>This platform uses the following third-party services:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Google AdSense:</strong> May use cookies to serve relevant advertisements based on your browsing activity. You may opt out of personalized advertising by visiting <a href="https://adssettings.google.com" className="text-[#C5A028] hover:underline" target="_blank" rel="noopener noreferrer">Google Ads Settings</a>.</li>
          <li><strong>Affiliate Links:</strong> We may earn a commission from purchases made through affiliate links (including Amazon Associates) at no additional cost to you. External sites have their own privacy policies.</li>
        </ul>
        <p>We are not responsible for third-party privacy practices.</p>

        <h3 className="text-lg font-semibold text-[#1C1917]">Cookies and Local Storage</h3>
        <p>We use browser local storage to store your preferences and session data. Google AdSense and other third-party services may use cookies. This storage:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Persists until you clear your browser data</li>
          <li>Is not shared with other websites or services by us</li>
          <li>Can be disabled through your browser settings</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1C1917]">California Consumer Privacy Act (CCPA)</h3>
        <p>If you are a California resident, you have the right to know what personal data is being collected, request its deletion, and not be discriminated against for exercising your privacy rights. Since we do not collect personal information beyond browser local storage, most of these rights are automatically satisfied.</p>

        <h3 className="text-lg font-semibold text-[#1C1917]">General Data Protection Regulation (GDPR)</h3>
        <p>For users in the European Economic Area, we comply with GDPR requirements. We do not collect, process, or store personal data on our servers. All user data is stored locally in your browser. You have the right to access, rectify, erase, restrict processing, and port your data. Since data is stored locally, you have full control through your browser settings.</p>

        <h3 className="text-lg font-semibold text-[#1C1917]">Your Rights</h3>
        <ul className="list-disc pl-6 space-y-1">
          <li>Clear all stored data through your browser settings</li>
          <li>Disable local storage functionality</li>
          <li>Use the platform without storing any data</li>
          <li>Opt out of personalized advertising</li>
          <li>Contact us with privacy-related questions</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1C1917]">Changes to This Policy</h3>
        <p>We may update this privacy policy from time to time. Changes will be reflected in this document with an updated revision date. Continued use of the platform constitutes acceptance of any changes.</p>

        <h3 className="text-lg font-semibold text-[#1C1917]">Contact</h3>
        <p>For privacy-related questions, email us at <a href="mailto:support@lifeownit.com" className="text-[#C5A028] hover:underline">support@lifeownit.com</a>.</p>

        <p className="text-xs text-[#78716C] mt-8">Last Updated: January 2026</p>
      </div>
      <SponsorBanner />
      <AdSensePlaceholder />
    </div>
  );
}
